module.exports = __webpack_public_path__ + "5f9bd6e1edf4ce9d0557426bd499d297.webp";